import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { ProjectDeadlineExtensionsCreate } from 'features/Project/pages/ProjectDeadlineExtensions/pages';

function ProjectDeadlineExtensionsCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <ProjectDeadlineExtensionsCreate />
      </Layout>
    </LayoutProvider>
  );
}

export default ProjectDeadlineExtensionsCreatePage;
